/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-04 01:22:58
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-04 01:39:24
 */

import React, { PureComponent, Fragment } from 'react';
import { shape } from 'prop-types';
import { Row, Col, Button, Icon } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AppWrappperHOC } from '../../Root/HOC';
import Journey from '../../../containers/NewLanding/Journey';
import endPoints from '../../../config/endPoints';
import { constants } from '../../../devUtils';
import { HelmetWrapper, LandingContainer, SubTitle } from '../../../components';

const StyledTeam = styled.section`
  .image-grayscale{
    filter: grayscale(100%);
  }
  h1{
    font-family: 'Mulish',sans-serif;
    color: ${({ theme }) => theme.LandingBlack};
  }
  p{
    color: ${({ theme }) => theme.LandingBlack};
  }
`;

class Team extends PureComponent {
  constructor(props) {
    super(props);
    this.state =
    {
      // chairman: false,
      // ceo: false,
      vp: false,
      cto: false,
      sales: false,
      hr: false,
      coo: false,
      cpo: false,
    };
  }

  chairman() {
    // const { chairman } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Raj P Narayanam​</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Executive Chairman​</SubTitle>
        <p>
          Raj P Narayanam is the Executive Chairman of our Company. He has been on the Board of our Company since April 30, 2012. He completed post graduate diploma in business management with specialisation in finance from the FORE School of Management, New Delhi. He has also completed his post graduate diploma on “Computer Systems” from Advance Computer Education and a certified online course on “Scaling a Business: How to Build a USD 1 Billion+ Unicorn” from The Wharton School, University of Pennsylvania. Further, he has completed an online programme and has been awarded the post graduate certificate in digital marketing from MICA, The School of Ideas. He has experience in the technology and fintech industry. He has also made varying levels of investments in certain companies at different points in time.
        </p>
        {/* {chairman ?
          <Fragment>
            <p>
            A key contributor to the Indian start-up ecosystem and a true visionary, he won the “Small Scale Entrepreneur of the Year” award in 2007. His futuristic outlook has been printed in magazines such as The Smart CEO, Business Today, Internet World, and Outlook Business.
            </p>
            <p>
            Raj has successfully led the team that consists of over 250+ employees across the country. He enjoys spending personal time organic farming, watching comedy shows, playing golf, cricket, and badminton.
            </p>
            <p>
            The Most Promising Business Leaders of Asia 2020-2021 by The Economic Times
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ chairman: !chairman })}>View {chairman ? 'Less' : 'More'}
            <Icon type={chairman ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div> */}
      </StyledTeam>
    );
  }

  chiefExecutiveOfficer() {
    // const { ceo } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Avinash Godkhindi</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Executive Officer and Managing Director</SubTitle>
        <p>
          Avinash Ramesh Godkhindi is the Managing Director and Chief Executive officer of our Company. He has been on the Board of our Company since May 7, 2012. He holds a bachelors’ degree in engineering from Bangalore University, Bengaluru and a masters’ degree in business administration from the University of Chicago, Chicago. He has been awarded the “Inspiring CEO” award by the Economic Times in 2022. Prior to this, he worked as an Assistant Vice President at Citibank N.A., India.
        </p>
        {/* {ceo ?
          <Fragment>
            <p>During his tenure at Citibank, he was credited with the biggest credit card launch in India, the "Premier Miles Credit Card".</p>
            <p>
            Avinash completed his MBA from the University of Chicago Booth School Of Business and is a fitness freak. When not in office, you would find him on the field playing cricket or football, or in the basketball court shooting a few balls. He is an avid reader and traveller, with wanderlust in his veins - to explore the far and unknown.
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ ceo: !ceo })}>View {ceo ? 'Less' : 'More'}
            <Icon type={ceo ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div> */}
      </StyledTeam>
    );
  }

  vicePresidentProducts() {
    const { vp } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Rajsekhar Gopisetti</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Vice President Products</SubTitle>
        <p>Rajsekhar Gopisetti is the Vice President (Products) at Zaggle. With over 20 years of experience in the fields of product development,
          project management, marketing, sales and strategy, he joined Zaggle in 2011. An innovator and a strategist, he has spearheaded the
          strategy and implementation road map for a range of prepaid product solutions for both corporates as well as consumers, crafting some
          of the most futuristic products in the digital space.
        </p>
        {vp ?
          <Fragment>
            <p>Prior to Zaggle, Rajsekhar successfully led and launched multiple initiatives for eYantra, Times Online Money Ltd., and Philips
              India Ltd. He also created corporate online brand stores for diverse companies such as TCS, HCL, Infosys, Capgemini and Dell.
            </p>
            <p>An alumnus of Indian Institute of Management (IIM) Lucknow, he is driven by his vision of helping build Zaggle into a world-class
              organization offering the best prepaid platforms.
            </p>
            <p>Rajsekhar is known for his gregarious personality both on the Zaggle floor as well as on the field playing his favourite sports.
              Outside work, he can be found organizing sports tournaments particularly badminton and bridge. A connoisseur of food and arts,
              he is the go-to person for restaurant recommendations in and around Hyderabad or reviews of the latest movies in town.
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ vp: !vp })}>View {vp ? 'Less' : 'More'}
            <Icon type={vp ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  chiefTechnicalOfficer() {
    const { cto } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Sivakumar Vondivillu</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Technology Officer</SubTitle>
        <p>Sivakumar Vondivillu is an Engineer from Thiagarajar College of Engineering, Madurai &#38; had done his Executive Program in Business
          Management from Indian Institute of Management, Calcutta.
        </p>
        <p>He is a passionate senior technology and engineering leader with versatile experience of 23+ years of excellence in engineering
          management and great hands-on software development. He is experienced in highly scalable and distributed architecture, analysis,
          design, development and managing software projects- predominantly in object oriented and internet/mobile technologies.
        </p>
        {cto ?
          <Fragment>
            <p>In his previous role, he was heading the technology as Group CTO for People Combine group which runs various school brands
              including Oakridge International Schools. Prior to that, he was associated with brands like University (an EdTech startup),
              ibibo (eCommerce startup), Quark (desktop publishing software) etc. He was instrumental in building various products from
              scratch at ibibo. Goibibo and PayU are some of the products he helped building from scratch which become billion dollar companies
              later.
            </p>
            <p>In his ME time, Siva loves reading books, watching movies, listening Tamil songs. He is also a sports lover and likes to play
              badminton, tennis, also follows cricket avidly. He is passionate in Yoga for fitness and loves to talk &#38; preach about it to the
              interested audience.
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ cto: !cto })}>View {cto ? 'Less' : 'More'}
            <Icon type={cto ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  chiefOperatingOfficer() {
    const { coo } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Arundhoti Banerjee</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Operating Officer</SubTitle>
        <p>Arundhoti Banerjee is Zaggle&#39;s Chief Operating Officer, responsible for business development and growth, customer success, user experience, engagement, operations, and partnerships.
          With over 15 years of experience, her expertise lies in business strategy, product development, strategic partnerships, and P&#38;L delivery.
          She was the founding member of Loyalty Rewards and exited successfully.
        </p>
        {coo ?
          <Fragment>
            <p>She has the ideal combination of strong leadership qualities, brilliant conceptual understanding, and effective business skills.
              She is extremely passionate about understanding customer needs and providing solutions based on insights and data.
              Influence-based leadership that improves collaboration.
            </p>
            <p>Arundhoti is a FinTech expert who has scaled growth-stage companies, making a significant contribution to their success and propelling them to IPO and beyond.
              She has built and led large teams while leading Finablr&#39;s digital cross-border payments business.
              She managed business strategy, product and market launches, and global strategic partnerships with banks, payment enterprises, and FinTech&#39;s.
            </p>
            <p>She is an IIM Ahmedabad graduate and is dedicated to delivering tangible business results</p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ coo: !coo })}>View {coo ? 'Less' : 'More'}
            <Icon type={coo ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  chiefFinancialOfficer() {
    // const { cfo } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Vidyaniwas Khetawat​</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Investor Relations Officer</SubTitle>
        <p>
        Vidyaniwas Khetawat is the Chief Strategy Officer of our Company. He holds a bachelors` degree in technology in chemical engineering from Indian Institute of Technology, Delhi, New Delhi, a masters’ degree in engineering from National University of Singapore, and a master’s degree in business administration from the University of Chicago. Prior to joining our Company, he worked at Nohara-Solargy Power, Hudson Clean Energy Partners.
        </p>
      </StyledTeam>
    );
  }

  chiefProductOfficer() {
    const { cpo } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Sathish N</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Product Officer</SubTitle>
        <p>Sathish N is the Chief Product Officer at Zaggle.
          He will lead the overall Product vision, strategy, design, and development of our existing and next generation products and platforms that will disrupt the Future of Fintech for enterprises, SMEs, and Startups.
          He is passionate about using design thinking, innovation-led and research backed Data driven methodologies in building meaningful solution with customer empathy at the core.
          He understands business, markets, technologies and has always worked closely with customers in finding ways to simplify their jobs to be done.
          He has filed a patent in 2019 on Human Centric Design, on how the future of banking products would be designed.
        </p>
        {cpo ?
          <Fragment>
            <p>He is a seasoned fintech product leader with over 25 years of experience in launching multiple enterprise-scale products &#38; platforms to global markets from India in the areas of Digital Transformation, Omni-Channel Engagement, Retail Payment stack, FinTech, Digital Lending, Customer Centricity, Revenue Management, Enterprise Product Catalogue, and Digital Core Banking.
            </p>
            <p>His strong industry expertise in the Banking &#38; financial sector, coupled with his passion for continuous learning, has led him to enhance business value to customers. He has travelled worldwide for work and worked with diverse customer base in the United States, Europe, ME, Africa, and APAC.
            </p>
            <p>He holds a bachelor&#39;s degree in electronics and communication engineering from Bharathiar University and was an integral part of a leadership program by INSEAD Business School.
              Sathish is active in the Indian Startup ecosystem as mentor, advisor, and engages in thought leadership information sharing session.
              He continuously thrives to increase the Prod Management quotient of the industry by actively sharing his knowledge.
              Sathish enjoys golfing, cooking with his family, and loves spending time in the wild capturing moments (@sathishN_sats), and is an active proponent of conservation.
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ cpo: !cpo })}>View {cpo ? 'Less' : 'More'}
            <Icon type={cpo ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  salesHeadWest() {
    const { sales } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Tushar Patil</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Regional Sales Head &#45; West</SubTitle>
        <p>Tushar Patil is the Vice President &#45; Sales at Zaggle. With over 18 years of successful experience in the banking and cement industry,
          he joined Zaggle in 2012 as the Regional Sales Head (West) and has been responsible for the promotion of digital payment instruments
          in Western India.
        </p>
        {sales ?
          <Fragment>
            <p>He has in-depth expertise in channel &#38; institutional sales, key account management, and relationship management while working in
              companies such as Lakshmi Cement, Binani Cement, ICICI Bank Ltd and Adecco. Being a Civil Engineer and an MBA (Marketing &#38; Finance)
              from SIMB, Pune, Tushar firmly believes that Zaggle&#39;s growth is based upon strong foundation of team work, perseverance, efficiency
              and persuasiveness.
            </p>
            <p>Outside the office, he spends his leisure time doing yoga and meditation. An avid traveller, he relishes every opportunity to
              explore a new place.
            </p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ sales: !sales })}>View {sales ? 'Less' : 'More'}
            <Icon type={sales ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  humanResources() {
    const { hr } = this.state;
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Priti Mhatre</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Senior Manager &#45; Human Resources</SubTitle>
        <p>Priti Mhatre is the Senior Manager &#45; Human Resources at Zaggle. She heads pan India HR and strives to streamline every functions
          in HR department.
        </p>
        <p>She brings in 14+ years of work experience with 6+ years in Human Resources and rest in Operations and Client servicing, worked
          with companies like Intelenet Global Services, First Advantage &#38; Ocwen Financial Solutions.
        </p>
        {hr ?
          <Fragment>
            <p>Priti is a post graduate from Mumbai University and has done Masters in Human Resource Management from Symbiosis, Pune.
            </p>
            <p>When not in office, Priti likes to watch movies, hands on culinary art, listening to music, travelling &#38; Zumba for fitness.</p>
          </Fragment> : ''}
        <div>
          <Button className="btn gray-btn" onClick={() => this.setState({ hr: !hr })}>View {hr ? 'Less' : 'More'}
            <Icon type={hr ? 'up' : 'down'} className="margin-l-1" />
          </Button>
        </div>
      </StyledTeam>
    );
  }

  chiefFinancialOffice() {
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Aditya Kumar GV</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Chief Financial Officer</SubTitle>
        <p>
        Aditya is the Chief Financial Officer of our Company. He is a member of the Institute of Chartered Accountants of India, New Delhi. Prior to joining our Company, he worked at Spandana Sphoorty Financial Limited as Vice President Investor Relations-Finance.
        </p>
      </StyledTeam>
    );
  }

  companySecretary() {
    return (
      <StyledTeam>
        <SubTitle fontWeight="900" className="font-20">Hari Priya</SubTitle>
        <SubTitle fontWeight="900" className="font-20">Company Secretary and Compliance Officer</SubTitle>
        <p>
        Hari Priya is the Company Secretary and Compliance Officer of our Company. She holds a bachelor’s degree in commerce from Devi Ahilya Vishwavidyalaya, Indore, and is a member of the Institute of Company Secretaries of India, New Delhi. Prior to joining our Company, she worked with Axis Clinicals Limited as assistant general manager-company secretary, Gayatri Projects Limited as assistant company secretary and Spandana Sphoorty Financial Limited as deputy company secretary and manager.
        </p>
      </StyledTeam>
    );
  }


  render() {
    const { location } = this.props;
    return (
      <StyledTeam>
        <HelmetWrapper location={location} />
        <div className="gray-greadient">
          <section className="padding-tb-5">
            <LandingContainer>
              <Row align="top" type="flex" justify="start" gutter={32}>
                <Col xs={24} sm={24} md={24} lg={11} xl={11} className="padding-t-3">
                  <p>Company</p>
                  <h1>The Leadership Team</h1>
                  <p className="padding-r-2">
                    Leadership is an art and We at Zaggle have diverse leaders from all corners to form an outstanding team that is helping us to craft the most innovative products to serve the business needs.
                  </p>
                  <Link to={constants.LINK_PRESS} className="btn red-btn margin-t-1">See Our Newsroom</Link>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                  <img
                    src={endPoints.TEAM_LANDING_IMAGE.URL}
                    alt={endPoints.TEAM_LANDING_IMAGE.ALT}
                    className="width-100 image-grayscale"
                  />
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <section>
            <LandingContainer>

              <Row align="top" type="flex" justify="start" gutter={32} className="padding-tb-4">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <img src={endPoints.FOUNDER_IMAGE.URL} alt={endPoints.FOUNDER_IMAGE.ALT} className="width-100 image-grayscale" />
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {this.chairman()}
                </Col>
              </Row>

              <Row align="top" type="flex" justify="start" gutter={32} className="padding-tb-4">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <img src={endPoints.CEO_IMAGE.URL} alt={endPoints.CEO_IMAGE.ALT} className="width-100 image-grayscale" />
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {this.chiefExecutiveOfficer()}
                </Col>
              </Row>
              {/* <Row align="top" type="flex" justify="start" gutter={32} className="padding-tb-4">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <img src={endPoints.CSO_IMAGE.URL} alt={endPoints.CSO_IMAGE.ALT} className="width-100 image-grayscale" />
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {this.chiefFinancialOfficer()}
                </Col>
              </Row> */}
              <Row align="top" type="flex" justify="start" gutter={32} className="padding-tb-4">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <img src={endPoints.CFO_IMAGE.URL} alt={endPoints.CFO_IMAGE.ALT} className="width-100 image-grayscale" />
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {this.chiefFinancialOffice()}
                </Col>
              </Row>
              <Row align="top" type="flex" justify="start" gutter={32} className="padding-tb-4">
                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                  <img src={endPoints.CSCO_IMAGE.URL} alt={endPoints.CSCO_IMAGE.ALT} className="width-100 image-grayscale" />
                </Col>
                <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                  {this.companySecretary()}
                </Col>
              </Row>
            </LandingContainer>
          </section>
          <Journey />
        </div>
      </StyledTeam>
    );
  }
}

Team.propTypes = {
  location: shape({}).isRequired,
};

const component = AppWrappperHOC(Team);

export { Team };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Team/index.js